import { Component, Input, OnInit } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { AuthenticationService } from '@core/authentication/authentication.service';

@Component({
  selector: 'app-error-login-view',
  templateUrl: './error-login-view.component.html'
})
export class ErrorLoginViewComponent implements OnInit {
  @Input() text: string;

  constructor(
    public appConfig: AppConfig,
    public authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    if (this.text === 'false') {
      this.text = this.appConfig.LANG.message.noLogin;
    }
  }

  logout() {
    this.authenticationService.logout();
  }
}
